
      <!--  TITLE BAR  -->

      <div class="title-bar head-bg">

          <!--  BACK ICON  -->

          <a *ngIf="uiLayoutConfig.hasViewTakeover && !!uiLayoutConfig.viewTakeoverBackPath" class="icon-button head-fg-col head-mix-hov-bg" [routerLink]="uiLayoutConfig.viewTakeoverBackPath">
              <i class="fas fa-arrow-left"></i>
          </a>

          <!--  END BURGER ICON  -->

          <!--  BURGER ICON  -->

          <a class="icon-button head-fg-col head-mix-hov-bg" (click)="onExpandNav()">
              <i class="fas fa-bars"></i>
              <span *ngIf="totalBadge.exists" class="badge" [ngClass]="totalBadge.cssClass">{{ totalBadge.value | uiMaxNumber:99 }}</span>
          </a>

          <!--  END BURGER ICON  -->

          <!--  TITLE  -->

          <h2 class="view-title head-fg-col">{{ viewTitle }}</h2>

          <!--  END TITLE  -->

      </div>

      <!--  END TITLE BAR  -->

      <!--  NAV CONTAINER  -->

      <div class="nav-container"
           [class.expanded]="!!uiLayoutConfig.navExpanded"
           [class.top-nav]="uiApp.navPosition === 'top'"
           [class.consumer]="uiApp.audience === 'consumer'"
           [class.has-module-nav]="uiAppModule.hasModuleNav && uiLayoutConfig?.hasViewTakeover !== true">

          <!--  MAIN NAV  -->

          <div class="main-nav head-bg">
              <nav>
                  <ul>

                      <!--  HOME ICON  -->

                      <li *ngIf="uiApp.audience !== 'consumer'" class="home">
                          <a class="icon-button acc-bg acc-hov-bg acc-fg-col"
                             [routerLink]="['/']"
                             [uiTooltipText]="'Home'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onCollapseNav()">
                              <i class="icon-click-dealer"></i>
                          </a>
                      </li>

                      <!-- END HOME ICON  -->

                      <!--  LOGO  -->

                      <li *ngIf="uiApp.audience === 'consumer'" class="logo" [class.failed-to-load]="logoFailedToLoad || !uiApp.logoUrl">
                          <a class="head-fg-col"
                             [routerLink]="['/' + uiAppModule?.path]"
                             [uiTooltipText]="'Home'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onCollapseNav()">
                              <img *ngIf="uiApp.logoUrl" [src]="uiApp.logoUrl" [alt]="uiApp.name" (error)="logoFailedToLoad = true">
                              <span class="collection-name">{{ uiApp.name }}</span>
                              <span class="collection-acronym pri-bg pri-fg-col" [class.trio]="uiApp.acronym.length === 3">{{uiApp.acronym}}</span>
                          </a>
                      </li>

                      <!--  END LOGO  -->

                      <!--  SPACER - KEY ICONS WITH MENU ITEMS  -->

                      <li *ngIf="uiApp.keyItemsPosition === 'withMenuItems'" class="spacer"></li>

                      <!--  END SPACER - KEY ICONS WITH MENU ITEMS  -->

                      <!--  MODULE SWITCHER  -->

                      <li *ngIf="uiApp.showModuleSwitcher">
                          <a class="icon-button head-mix-hov-bg"
                             [uiTooltipText]="'Go to...'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onKeyNavItemClick('switch-modules')">
                              <i class="fas fa-th head-fg-col"></i>
                          </a>
                      </li>

                      <!--  END MODULE SWITCHER  -->

                      <!--  SEARCH  -->

                      <li *ngIf="uiApp.showSearch">
                          <a class="icon-button head-mix-hov-bg"
                             [uiTooltipText]="'Search'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onKeyNavItemClick('search')">
                              <i class="fas fa-search head-fg-col"></i>
                          </a>
                      </li>

                      <!--  END SEARCH  -->

                      <!--  SPACER - KEY ICONS FIRST  -->

                      <li *ngIf="uiApp.keyItemsPosition === 'default'" class="spacer"></li>

                      <!--  END SPACER - KEY ICONS FIRST  -->


                      <!--  ICONS LOOP  -->

                      <li *ngFor="let mainNavItem of uiApp.mainNavItems">
                          <a class="icon-button head-mix-hov-bg"
                             [class.has-badge]="!!mainNavItem.badge"
                             [uiTooltipText]="mainNavItem.tooltipText"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onMainNavItemClick(mainNavItem)">
                              <i class="head-fg-col" [ngClass]="mainNavItem.icon"></i>
                              <span *ngIf="mainNavItem.badge"
                                    class="badge"
                                    [ngClass]="[uiThemeService.buildCssClass(mainNavItem.badge.theme, 'bg'), uiThemeService.buildCssClass(mainNavItem.badge.theme, 'col', 'fg')]">
                                  {{ mainNavItem.badge.value | uiMaxNumber:99 }}
                              </span>
                          </a>
                      </li>

                      <!--  END ICONS LOOP  -->

                      <!--  DEALER SWITCHER  -->

                      <li *ngIf="uiApp.audience !== 'consumer' && me && me.multi_dealer" class="dealer-switcher hidden-sm1 hidden-sm2 hidden-sm3">
                          <a class="head-mix-hov-bg"
                             [uiTooltipText]="'Switch Dealer...'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onSwitchDealerClick()">
                              <i class="fas fa-building head-fg-col"></i>
                              <span class="head-fg-col">{{ me.current_dealer.brand_name }}</span>
                          </a>
                      </li>

                      <li *ngIf="uiApp.audience !== 'consumer' && me && me.multi_dealer" class="visible-sm1 visible-sm2 visible-sm3">
                          <a class="icon-button head-mix-hov-bg"
                             [uiTooltipText]="'Switch Dealer...'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onSwitchDealerClick()">
                              <i class="fas fa-building head-fg-col"></i>
                          </a>
                      </li>

                      <!--  END DEALER SWITCHER  -->

                      <!--  USER ACCOUNT  -->

                      <li *ngIf="uiApp.showUserAccount && me">

                          <!--  ACCOUNT ICON  -->

                          <a *ngIf="!me.avatar_path" class="icon-button head-mix-hov-bg"
                             [uiTooltipText]="'Account'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onKeyNavItemClick('user-account')">
                              <i class="fas fa-user head-fg-col"></i>
                          </a>

                          <!--  END ACCOUNT ICON  -->

                          <!--  USER AVATAR  -->

                          <a *ngIf="!!me.avatar_path" class="avatar"
                             [uiTooltipText]="'Account'"
                             [uiTooltipConfig]="mainNavTooltip"
                             (click)="onKeyNavItemClick('user-account')">
                              <img [src]="me.avatar_path" [alt]="me.full_name">
                          </a>

                          <!-- END USER AVATAR  -->

                      </li>

                      <!--  END USER ACCOUNT  -->

                  </ul>
              </nav>
          </div>

          <!--  END MAIN NAV  -->

          <!--  MODULE NAV  -->

          <div *ngIf="uiAppModule?.hasModuleNav && uiLayoutConfig?.hasViewTakeover !== true" class="module-nav">

              <!--  MODULE NAV HEADING  -->

              <div class="module-nav-header">
                  <h1>{{uiAppModule?.name}}</h1>
                  <a class="icon-button" (click)="onCollapseNav()">
                      <i class="far fa-times"></i>
                  </a>
              </div>

              <!--  END MODULE NAV HEADING  -->

              <!--  MODULE NAV ITEMS  -->

              <nav *ngIf="uiAppModule?.navItems !== null && uiAppModule?.navItems.length > 0">

                  <ui-nav-list [navItems]="uiAppModule?.navItems" [parentPath]="uiAppModule?.path" (navigation)="onCollapseNav()"></ui-nav-list>

              </nav>

              <!--  END MODULE NAV ITEMS  -->

          </div>

          <!--  END MODULE NAV  -->

      </div>

      <!--  END NAV CONTAINER  -->

      <!--  OVERLAY  -->

      <div class="overlay" [class.show]="!!uiLayoutConfig.navExpanded" (click)="onCollapseNav()"></div>

      <!--  END OVERLAY  -->
    